var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path6, _path7, _rect12, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 108,
    viewBox: "0 0 149 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.61 103.88C121.61 106.157 100.41 108 74.2602 108C48.1082 108 26.9087 106.157 26.9087 103.88C26.9087 101.606 48.1082 99.7627 74.2602 99.7627C100.41 99.7627 121.61 101.606 121.61 103.88Z",
    fill: "#E6F9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4582 0C38.0752 0 7.76904 31.0562 7.76904 69.3646C7.76904 79.5698 9.93679 89.2514 13.8001 97.9774H137.116C140.98 89.2514 143.147 79.5698 143.147 69.3646C143.147 31.0562 112.841 0 75.4582 0Z",
    fill: "#05C3DE",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61523 97.9778H140.609",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 97.9778H5.23057",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.993 97.9778H148.224",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.8433,
    y: 52.1694,
    width: 67.8989,
    height: 41.1865,
    fill: "#82E1EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6221,
    y: 92.9421,
    width: 93.701,
    height: 8.15256,
    rx: 1,
    fill: "white",
    stroke: "#086EA1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6626,
    y: 56.3311,
    width: 13.2945,
    height: 32.8645,
    fill: "white",
    stroke: "#086EA1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.8252,
    y: 56.3311,
    width: 13.2945,
    height: 32.8645,
    fill: "white",
    stroke: "#086EA1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 98.8813,
    y: 56.3311,
    width: 13.2945,
    height: 32.8645,
    fill: "white",
    stroke: "#086EA1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1958,
    y: 52.6694,
    width: 21.3351,
    height: 3.57628,
    rx: 1,
    fill: "white",
    stroke: "#086EA1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1958,
    y: 89.2805,
    width: 21.3351,
    height: 3.57628,
    rx: 1,
    fill: "white",
    stroke: "#086EA1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3584,
    y: 52.6694,
    width: 21.3351,
    height: 3.57628,
    rx: 1.5,
    fill: "white",
    stroke: "#086EA1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3584,
    y: 89.2805,
    width: 21.3351,
    height: 3.57628,
    rx: 1,
    fill: "white",
    stroke: "#086EA1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4146,
    y: 52.6694,
    width: 21.3351,
    height: 3.57628,
    rx: 1,
    fill: "white",
    stroke: "#086EA1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4146,
    y: 89.2805,
    width: 21.3351,
    height: 3.57628,
    rx: 1,
    fill: "white",
    stroke: "#086EA1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5462 17.6729C71.2933 16.4119 73.6517 16.4119 75.3987 17.6729L111.782 43.9337H33.1626L69.5462 17.6729Z",
    fill: "white",
    stroke: "#086EA1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4937 26.9248C71.2629 25.6124 73.6826 25.6124 75.4517 26.9248L98.3815 43.9352H46.564L69.4937 26.9248Z",
    fill: "#05C3DE",
    fillOpacity: 0.5,
    stroke: "#086EA1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31.876,
    y: 44.4346,
    width: 81.1934,
    height: 8.15256,
    rx: 1,
    fill: "white",
    stroke: "#086EA1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.929 102.508C126.331 102.508 132.33 96.3616 132.33 88.7794C132.33 81.1971 126.331 75.0505 118.929 75.0505C111.528 75.0505 105.528 81.1971 105.528 88.7794C105.528 96.3616 111.528 102.508 118.929 102.508Z",
    fill: "white",
    stroke: "#086EA1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.153 81.9138V95.6427",
    stroke: "#05C3DE",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.229 88.7791H125.63",
    stroke: "#05C3DE",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankImage);
export default __webpack_public_path__ + "static/media/BankImage.569f32a5e6125b66116c72ee5b1294a9.svg";
export { ForwardRef as ReactComponent };